export var RISK_BAD_UX_DISABLE_TOOLTIP = 'Tried using `common.no-changes` from translations but i know what im doing so i dont need a tooltip for UX';
//# sourceMappingURL=constants.js.map